<template>
  <div class="about-uplus">
    <div class="top-content">
      <div class="about-content">
        <div class="title">
          关于U+
        </div>
        <div class="sub-title description">
          U+是恒生电子的服务品牌，源自恒生创立伊始即秉承的“客户第一”初心。
        </div>
        <div class="description">
          我们相信，未来金融科技的服务边界将不断拓展。U+致力于构建全生命周期的金融科技服务生态体系，不仅为广大客户提供高效、专业、透明的售后和交付服务，同时为金融行业搭建了一个知识分享、互动和交流的平台，与客户共同成长。客户在U+上还能便捷的获取恒生最新的数字化产品与解决方案。
        </div>
        <div class="description">
          U+目前包含U+客户服务网站、U+APP、微信服务公众号等多个在线服务入口，客户通过这些入口能够享受到U+全方位交互式的客户服务体验。
        </div>
        <div class="description">
          不断超越客户期望，为客户带来持续价值增长，是U+永恒的追求。<a class="download-icon" href="javascript:;" @click="goAboutUplus">点击下载U+介绍<img src="~@/assets/uplus/download_icon.png"></a>
        </div>
      </div>
    </div>
    <div class="uplus-history">
      <div class="title">
        U+动态
      </div>
    </div>
    <div class="connect-content">
      <div class="title">
        联系我们
      </div>
      <div class="connect-box">
        <img class="connect-map" src="../../assets/uplus/hs_map.png" />
        <div class="connect-info">
          <p>客服热线 0571-28829999</p>
          <p>客服邮箱 service@hundsun.com</p>
          <p>客服网址 https://www.hs.net</p>
          <p>投诉电话 0571-28829999</p>
          <p>投诉邮箱 complaint@hundsun.com</p>
        </div>
      </div>
    </div>
    <connectUplus />

    <index-footer></index-footer>
  </div>
</template>
<script>
import IndexFooter from "@/components/index/indexFooter";
export default {
  name: "uplus",
  components: {
    IndexFooter
  },
  methods: {
    // 跳转到U+介绍预览页面
    goAboutUplus() {
      window.open(`/online-console/static/pdf/web/viewer.html?file=${encodeURIComponent('/uplus/about')}`)
    }
  }
};
</script>
<style lang="scss" scoped>
.about-uplus {
  background: #fff;
  .title {
    width: 1200px;
    margin: 0 auto;
    padding-top: 40px;
    font-family: PingFangSC-Medium;
    font-size: 26px;
    color: #333333;
    line-height: 26px;
    font-weight: 500;
  }
  .top-content {
    height: 400px;
    width: 100%;
    background: url("../../assets/uplus/bg.jpg");
    background-size: cover;
    background-position: 50% 50%;
  }
  .about-content {
    width: 1200px;
    margin: 0 auto;
    .title {
      padding-top: 100px;
      font-family: PingFangSC-Medium;
      font-size: 26px;
      color: #333333;
      line-height: 26px;
      font-weight: 500;
    }
    .sub-title {
      // font-family: PingFangSC-Medium;
      // font-size: 20px;
      // color: #333333;
      // line-height: 20px;
      // font-weight: 500;
      padding-top: 40px;
      // padding-bottom: 12px;
    }
    .description {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #333333;
      line-height: 22px;
      font-weight: 400;
      width: 958px;
    }
  }
  .uplus-history {
    height: 453px;
    width: 100%;
    background: url("../../assets/uplus/about_us.jpg");
    background-size: cover;
    background-position: 50% 50%;
  }
  .connect-content {
    height: 453px;
    width: 1200px;
    margin: 0 auto;
    .title {
      padding-top: 70px;
    }
    .connect-box {
      display: flex;
    }
    .connect-map {
      width: 426px;
      height: 220px;
      margin: 40px 80px 100px 126px;
    }
    .connect-info {
      margin-top: 45px;
      p {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333333;
        line-height: 42px;
        font-weight: 400;
        margin-bottom: 0;
      }
    }
  }
}
.uplus-back {
  width: 100%;
  height: 200px;
  background: url("./../../assets/index/uplus-bg.png");
  background-size: cover;
  background-position: 50% 50%;

  .uplus-content {
    width: 1200px;
    height: 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
  }
  .left {
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    line-height: 32px;
    font-weight: 500;
    padding-left: 80px;
  }
  .aboutUPlus {
    margin-right: 128px;
    height: 32px;
    width: 128px;
    background: #5e97ff;
    border-radius: 2px;
    border: 1px solid rgba(255, 255, 255, 1);
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #fff;
    letter-spacing: 0;
    text-align: center;
    line-height: 32px;
    font-weight: 400;
    cursor: pointer;
    &:hover {
      box-shadow: 0px 5px 10px 0px rgba(0, 76, 255, 0.5);
    }
  }
}
.download-icon {
  color: #004cff;
  img {
    width: 14px;
    height: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/uPlus/index.vue